import React from "react";
import { Layout } from "antd";
import ThemeSwitcher from "../components/ThemeSwitcher";
import { useBranding } from "../context/ThemeContext";
const { Header } = Layout;

export default function CustomHeader() {
  const { title, logoUrl } = useBranding();

  return (
    <Header
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "var(--header-background)",
        padding: "0 32px",
        height: "70px",
        lineHeight: "70px",
        position: "relative", // ThemeSwitcher 以 Header 為定位基準
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
        borderBottom: "1px solid var(--border-color)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
        {logoUrl && (
          <img
            src={logoUrl}
            alt=""
            style={{ height: "40px", maxHeight: "40px", width: "auto", objectFit: "contain" }}
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        )}
        <h2
          style={{
            padding: 0,
            margin: 0,
            color: "var(--nav-text)",
            fontSize: "24px",
            fontWeight: 600,
            letterSpacing: "0.5px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </h2>
      </div>
      <div style={{ position: "absolute", right: "32px", display: "flex", gap: "12px" }}>
        <ThemeSwitcher />
      </div>
    </Header>
  );
}